<template>
    <div class="slider">
        <el-carousel height="600px" class="slider-carousel">
            <el-carousel-item v-for="(item, index) in sliders" :key="index" style="display: flex;justify-content: center;">
                <img :src="item.fileUrl.fileAbsPath" class="slider_img" mode="aspectFit">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import {
    getAppBanner
} from "@/api/api";
export default {
    name: 'Index',
    data() {
        return {
            sliders: [],
            videoTypeArr: ['avi', 'wmv', 'mpeg', 'mp4', 'm4v', 'mov', 'asf', 'flv', 'f4v', 'rmvb', 'rm', '3gp', 'vob']
        }
    },
    methods: {
        async getBanner() {
            let params = {
                bannerGroup: 1,
            };
            let res = await getAppBanner(params)
            if (res.code == 200) {
                const list = res.data;
                const newList = list.map((item) => {
                    const fileType = this.getFileType(item.fileUrl.fileAbsPath);
                    return {
                        ...item,
                        fileType
                    };
                })
                this.sliders = newList
            }
        },
        getFileType(fileName) {
            const fileSuffix = this.getFileSuffix(fileName);
            const index = this.videoTypeArr.findIndex((item) => item == fileSuffix);
            let fileType = 'image';
            if (index > -1) {
                fileType = 'video';
            }
            return fileType;
        },
        getFileSuffix(fileName) {
            var flieArr = fileName.split('.');
            const suffix = flieArr[flieArr.length - 1];
            return suffix;
        }
    },
    created() {
        this.getBanner()
    },
    computed: {
        //计算高度
        computeHeight() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                return '550px';
            } else {
                return '250px';
            }
        },
    },
}
</script>

<style scoped>
.slider {
    width: 100%;

}
.slider-carousel {
    width: 80%;
    margin: 0 auto;
}
.slider_img {
    height: 600px;
    width: auto;
    
}
</style>
